module.exports = __webpack_public_path__ + "static/media/profiles.b1ce186e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/profiles.png
// module id = 807
// module chunks = 29